module.exports = __webpack_public_path__ + "static/media/shower-rain.f1e6216a.png";